import React from 'react';

import { Input } from 'antd';

import styled from 'styled-components';

import CustomSwitch from '@components/Gui/CustomSwitch';
import DateSelector from '@components/Gui/NwForm/DateSelector';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 0.5rem;

    .line {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 0.5rem;

        label {
            font-size: ${(props) => props.theme.FontSizeSm};
            color: ${(props) => props.theme.TextColorMuted};
            text-transform: uppercase;
            width: 5rem;
        }
        .control {
            flex: 1;
            width: 100%;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
            gap: 0.5rem;

            @media (max-width: 768px) {
                flex-direction: column;
                align-items: flex-start;
                justify-content: flex-start;
            }
        }
    }
`;

const LocationDateSelector = ({ value, allDaySelectable, onChange }) => {
    const handlePlaceChange = (event) => {
        onChange({
            ...value,
            Place: event.target.value,
            Date: value.Date,
        });
    };

    const handleDateChange = (date) => {
        onChange({
            ...value,
            Date: date,
        });
    };

    const handleChangeAllDay = (allDay) => {
        onChange({
            ...value,
            allDay: allDay,
        });
    };

    return (
        <Wrapper>
            <div className="line">
                <label>Place</label>
                <div className="control">
                    <Input
                        autoComplete="off"
                        value={value ? value.Place : ''}
                        defaultValue=""
                        onChange={handlePlaceChange}
                        maxLength={200}
                    />
                </div>
            </div>
            <div className="line">
                <label>Date/Time</label>
                <div className="control">
                    <DateSelector
                        //text="Date/Time"
                        labelMinWidth={100}
                        dateOnly={value.disableTime}
                        beforeTime={value.beforeTime}
                        value={value.Date}
                        beforeDate={value.beforeDate}
                        onChange={handleDateChange}
                    />
                    {allDaySelectable && (
                        <CustomSwitch value={value.allDay} text="all day" onChange={handleChangeAllDay} />
                    )}
                </div>
            </div>
        </Wrapper>
    );
};

export default LocationDateSelector;
